import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { User } from '../../../types/Users.types';
import DeleteUserDialog from './DeleteAdminDialog';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';

interface UsersTableDesktopProps {
  users?: User[];
  impersonationLock: boolean;
  onDeleteUser: (email: string) => void;
}

export const AdminsTableDesktop = ({
  users,
  impersonationLock,
  onDeleteUser,
}: UsersTableDesktopProps) => {
  const { t } = useTranslation();

  return (
    <Table sx={{ minWidth: 650 }} aria-label="Admins list">
      <TableHead>
        <TableRow>
          <TableCell>{t('userManagement.account')}</TableCell>
          <TableCell>{t('userManagement.email')}</TableCell>
          <TableCell>{t('userManagement.updatedAt')}</TableCell>
          <TableCell>{t('userManagement.lastLogin')}</TableCell>
          <TableCell>
            <span className="sr-only">{t('userManagement.accions')}</span>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {users?.map((user: User) => (
          <TableRow key={`${user.email}-${user.app_metadata?.account}`}>
            <TableCell>{user.app_metadata?.account}</TableCell>
            <TableCell>{user.email}</TableCell>
            <TableCell>{dayjs(user.updated_at).format('YYYY-MM-DD')}</TableCell>
            <TableCell>
              {user.last_login
                ? dayjs(user.last_login).format('YYYY-MM-DD')
                : ''}
            </TableCell>
            <TableCell>
              <DeleteUserDialog
                disabled={impersonationLock}
                onClick={() => onDeleteUser(user.email)}
              />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
